import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { memo } from 'react';
import { Card } from '@mui/material';
import { CardContent } from '@mui/material';
import { CardActions } from '@mui/material';
import { Annotations } from 'civil-status/view-models/step-form';
import { FormControlLabel } from '@mui/material';
import { Checkbox } from '@mui/material';

interface FormAnnotationProps {
  index: number;
  onChange: (index: number, key: keyof Annotations, value: Annotations[keyof Annotations]) => void;
  onSave: (index: number, values?: Annotations) => void;
  onDelete: (index: number) => void;
  onClean: (index: number) => void;
  values?: Annotations;
  disabled?: boolean;
  isAnncont312?: boolean;
}

const FormAnnotationComponent = ({
  index,
  onChange,
  values,
  disabled = false,
  isAnncont312 = false,
  onSave,
  onDelete,
  onClean,
}: FormAnnotationProps): React.ReactElement => {
  return (
    <Card raised className="pmi-my-3">
      <CardContent style={{ padding: '24px' }}>
        <div style={{ padding: '24px 0 0 0' }}>
          <Grid container spacing={2}>
            <Grid item container xs={12} spacing={2}>
              <Grid item xs={12} md={8}>
                <PmiTextField
                  label="Tipo annotazione contestuale"
                  id="typeContextualAnnotation"
                  fullWidth
                  disabled={disabled}
                  value={values?.typeContextualAnnotation || ''}
                  onChange={(event) =>
                    onChange(index, 'typeContextualAnnotation', event?.target.value)
                  }
                />
              </Grid>
              {isAnncont312 ? undefined : (
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="isNotCertifiable"
                        checked={values?.isNotCertifiable || false}
                        onChange={() => {
                          onChange(index, 'isNotCertifiable', !values?.isNotCertifiable);
                        }}
                        inputProps={{ 'aria-label': 'Dichiara come non certificabile' }}
                        disabled={disabled}
                      />
                    }
                    label="Dichiara come non certificabile"
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <PmiTextField
                  label="Testo annotazione contestuale"
                  id="textContextualAnnotation"
                  fullWidth
                  multiline
                  rows={5}
                  disabled={disabled}
                  value={values?.textContextualAnnotation || ''}
                  onChange={(event) =>
                    onChange(index, 'textContextualAnnotation', event?.target.value)
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </CardContent>
      <CardActions style={{ padding: '24px 24px 16px 24px' }}>
        <PmiButton
          disabled={!values?.textContextualAnnotation?.trim() || disabled}
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onSave(index, values)}
        >
          Salva
        </PmiButton>
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={() => onDelete(index)}
          disabled={disabled}
        >
          Elimina
        </PmiButton>
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={() => onClean(index)}
          disabled={disabled}
        >
          Pulisci
        </PmiButton>
      </CardActions>
    </Card>
  );
};

FormAnnotationComponent.displayName = 'Annotation form component';

const FormAnnotation = memo(FormAnnotationComponent);

export default FormAnnotation;
